import { useCallback } from 'react'
import { useAddErrorContext } from 'src/context/useAddErrorContext' 

export const useErrorHandler = () => {
  const addError = useAddErrorContext()
  return useCallback(
    (error, callback = {}) => {
      addError(error, callback)
    },
    [addError]
  )
}
